import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

export class Service {
    public handleError(error: any) {
        let errMsg: string;

        if (error instanceof Response) {
            let body: any;
            try {
                body = error.json();
            } catch (e) {
                body = error.text();
            }

            const err = body.error || body.Message || (typeof body === 'string' ? body : JSON.stringify(body));
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }

        console.error('API Error:', errMsg, error);
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/service.ts